<template>
  <div>
    <Title :pages="[{ icon: 'barcode', page: page_title.toUpperCase() + 's' }]"></Title>

    <v-container fluid>
      <Modal
        v-if="create_access"
        :button_name="'Crear ' + modal_title"
        :modal_title="modal_title"
        :page_title="page_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :editItem="mainItem"
      />

      <v-card class="mb-4">
        <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
          <div class="col-md-12">
            <div class="col-md-12" style="background: white">
              <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
              <v-divider class="mt-0"></v-divider>
              <div class="row pt-2">
                <div class="col-md-3">
                  <v-text-field v-model="filters.creation_date_from" density="comfortable" type="date" name="creation_date_from" label="Desde" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.creation_date_to" density="comfortable" type="date" name="creation_date_to" label="hasta" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.almacen"
                    density="comfortable"
                    name="almacen"
                    item-title="name"
                    item-value="id"
                    :items="almacenes"
                    label="Almacen"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.state"
                    density="comfortable"
                    name="state"
                    item-title="name"
                    item-value="id"
                    :items="states"
                    label="Estado"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                    :loading="loading_states"
                  ></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.cubication_type"
                    density="comfortable"
                    name="cubication_type"
                    item-title="name"
                    item-value="id"
                    :items="cubication_types"
                    label="Tipo de Cubicaje"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.flow_type"
                    density="comfortable"
                    name="flow_type"
                    item-title="name"
                    item-value="id"
                    :items="flow_types"
                    label="Tipo de Flujo"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-3">
                  <v-text-field v-model="filters.desde_code" density="comfortable" name="desde_code" label="Desde Codigo LPN" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.hasta_code" density="comfortable" name="hasta_code" label="Hasta Codigo LPN" :disabled="disabled"></v-text-field>
                </div>

                <div class="col-md-12 mt-2" style="display: flex; justify-content: end">
                  <v-btn color="info" class="" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col>
              <span>{{ page_title }}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
        <div class="mb-4 mt-2" v-show="update_access">
          <v-tooltip bottom>
            <template v-slot:activator="{ props }">
              <v-icon
                :color="selected.length == 0 ? 'grey' : 'purple'"
                @click="selected.length == 0 ? null : printSeleted()"
                :class="selected.length == 0 ? 'ml-4 cursor-default' : 'ml-4 cursor-pointer'"
                v-bind="props"
              >
                mdi-printer</v-icon
              >
            </template>
            <span>Imprimir seleccionados</span>
          </v-tooltip>
        </div>
        <v-data-table :items-per-page="0" :headers="headers" :items="list" :search="search" :loading="loading" v-model="selected" show-select loading-text="Cargando..." :hide-default-footer="true">
          <template v-slot:item="{ item, isSelected, toggleSelect }">
            <tr>
              <td class="pl-2">
                <v-checkbox style="margin: 0px; padding: 0px" hide-details :model-value="isSelected({ value: item.id })" @update:modelValue="toggleSelect({ value: item.id })" />
              </td>
              <td>{{ item.creation_date }}</td>
              <td>{{ item.almacen.name }}</td>
              <td>
                <div class="font-weight-medium">
                  <b>{{ item.code }}</b>
                </div>
              </td>
              <td>{{ (item.cubication_type != null)?item.cubication_type.name : '-' }}</td>
              <td>{{ item.flow_type.name }}</td>
              <td>
                <v-chip size="small" class="mt-1">{{ item.state.name }}</v-chip>
              </td>
              <td class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="purple" class="mr-2" v-on:click="print(item)" size="small"> mdi-printer</v-icon>
                  </template>
                  <span>Imprimir</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="viewHistory(item)" size="small"> mdi-timer</v-icon>
                  </template>
                  <span>Ver historial</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="orange" class="mr-2" v-on:click="editCubicationType(item)" size="small"> mdi-cube-outline</v-icon>
                  </template>
                  <span>Editar tipo de Cubicaje</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" :loading="loadingSubmit" />

      <ModalPrint :show="dialog_print" @close="dialog_print = false" :selected="selected" :list="list" @cleanSelected="selected = []" />

      <ModalHistory :show="dialog_history" @close="dialog_history = false" :code="code_history" />

      <ModalCubicationTypes :dialog="dialog_cubication" @close="dialog_cubication = false" :lpnItem="lpn_item_cubication" :service="service" 
      @loadList="loadList(service)" />

      <div class="text-right mt-2">
        <small class="text-grey">
          {{ paginationText }}
        </small>
      </div>
      <v-pagination
        v-if="cant_pages > 1"
        v-model="current_page"
        :length="cant_pages"
        total-visible="10"
        @next="loadPage(service)"
        @prev="loadPage(service)"
        @first="loadPage(service)"
        @update:modelValue="loadPage(service)"
        class="mt-4"
      ></v-pagination>
    </v-container>
  </div>
</template>

<script>
import { lpnService } from "@/libs/ws/lpnService";
import { almacenService } from "@/libs/ws/almacenService";
import { cubicationTypeService } from "@/libs/ws/cubicationTypeService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Modal from "./Modal.vue";
import ModalPrint from "./ModalPrint.vue";
import ModalHistory from "./ModalHistory.vue";
import ModalCubicationTypes from "./ModalCubicationTypes.vue";
export default {
  components: { Modal, ModalPrint, ModalHistory, ModalCubicationTypes },
  mixins: [GenericMixin, RolMixin],
  RolMixin,
  data() {
    return {
      service: lpnService,
      page_title: "LPN",
      modal_title: "LPN",
      dialog_print: false,
      selected: [],
      dialog_history: false,
      code_history: null,
      dialog_cubication: false,
      lpn_item_cubication: null,
      filters: {
        desde_code: "",
        hasta_code: "",
        state: null,
        creation_date_from: null,
        creation_date_to: null,
        almacen: null,
        cubication_type: null,
        flow_type: null,
      },
      headers: [
        {
          title: "Fecha de creacion",
          align: "left",
          sortable: true,
          key: "creation_date",
        },
        {
          title: "Almacen",
          align: "left",
          sortable: true,
          key: "almacen.name",
        },
        {
          title: "LPN",
          align: "left",
          sortable: true,
          key: "code",
        },
        {
          title: "Tipo de Cubicaje",
          align: "left",
          sortable: true,
          key: "cubication_type.name",
        },
        {
          title: "Tipo de Flujo",
          align: "left",
          sortable: true,
          key: "flow_type.name",
        },
        {
          title: "Estado",
          align: "left",
          sortable: true,
          key: "state.name",
        },
        { title: "Accion", align: "center", sortable: false, key: "" },
      ],
      loading_states: false,
      states: [],
      almacenes: [],
      cubication_types: [],
      flow_types: [
        { id: "I", name: "Recepción" },
        { id: "O", name: "Expedición" },
      ],
    };
  },
  mounted() {
    this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));
    this.loadList(this.service);
    this.loadStates();
    this.loadAlmacenes();
    this.loadCubicationTypes();
  },
  methods: {
    getFilterParams() {
      return this.filters;
    },
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadCubicationTypes() {
      cubicationTypeService
        .filter({})
        .then((response) => {
          this.cubication_types = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    filter() {
      this.current_page = 1;
      this.loadList(this.service);
    },
    viewHistory(item) {
      this.code_history = item.code;
      this.dialog_history = true;
    },
    editCubicationType(item) {
      this.lpn_item_cubication = item;
      this.dialog_cubication = true;
    },
    printSeleted() {
      this.dialog_print = true;
    },
    print(item) {
      this.selected = [];
      this.selected.push(item.id);
      this.dialog_print = true;
    },
    loadStates() {
      this.loading_states = true;

      lpnService
        .list_states()
        .then((response) => {
          if (response.status) {
            this.states = response.result.list;
          }
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_states = false;
        });
    },
  },
};
</script>
